import { Image } from "@nextui-org/react";
import React from "react";
import { allusericon, revenueicon } from "../../assets";
import { LiaIdCard } from "react-icons/lia";
import { PiUsers } from "react-icons/pi";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

const Overview = ({ dashboardData, recalltotalRevenue }) => {
  const revenueTotal = parseInt(dashboardData?.revenue?._sum?.totalPrice || 0);
  const totalRevenue = revenueTotal + (recalltotalRevenue || 0);

  const data = {
    labels: ["Revenue", "Recall Revenue"],
    datasets: [
      {
        label: "Revenue Breakdown",
        data: [revenueTotal, recalltotalRevenue],
        backgroundColor: ["rgba(75, 192, 192, 0.5)", "rgba(255, 99, 132, 0.5)"],
        borderColor: ["rgba(75, 192, 192, 1)", "rgba(255, 99, 132, 1)"],
        borderWidth: 1,
      },
    ],
  };

  const doughnutOptions = {
    rotation: -90,
    circumference: 180,
    plugins: {
      legend: {
        display: false,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <div className="Overview mt-10">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4 sm:gap-5">
        <div className="rounded-lg border group border-[#F5F5F5] hover:bg-themeBtn-0 hover:border-themeBtn-0 duration-100 flex justify-between pt-4 pb-4 px-5">
          <div className="w-full">
            <p className="capitalize group-hover:text-white text-[#8F8F8F] text-sm mb-4">
              all member
            </p>
            <p className="text-black group-hover:text-white text-lg font-bold">
              {dashboardData?.totalUsers}
            </p>
          </div>
        </div>

        <div className="rounded-lg border group border-[#F5F5F5] hover:bg-themeBtn-0 hover:border-themeBtn-0 duration-100 flex justify-between pt-4 pb-4 px-5">
          <div className="w-full">
            <p className="capitalize group-hover:text-white text-[#8F8F8F] text-sm mb-4">
              Subscribed Members
            </p>
            <p className="text-black group-hover:text-white text-lg font-bold">
              {dashboardData?.subscribed}
            </p>
          </div>
        </div>

        <div className="rounded-lg border group border-[#F5F5F5] hover:bg-themeBtn-0 hover:border-themeBtn-0 duration-100 flex justify-between pt-4 pb-4 px-5">
          <div className="w-full">
            <p className="capitalize group-hover:text-white text-[#8F8F8F] text-sm mb-4">
              Unsubscribed Members
            </p>
            <p className="text-black group-hover:text-white text-lg font-bold">
              {dashboardData?.unSubscribed}
            </p>
          </div>
        </div>

        <div className="rounded-lg border group border-[#F5F5F5] hover:bg-themeBtn-0 hover:border-themeBtn-0 duration-100 flex justify-between pt-4 pb-4 px-5">
          <div className="w-full">
            <p className="capitalize group-hover:text-white text-[#8F8F8F] text-sm mb-4">
              Revenue
            </p>
            <p className="text-black group-hover:text-white text-lg font-bold">
              $ {revenueTotal}
            </p>
          </div>
        </div>

        <div className="rounded-lg border group border-[#F5F5F5] hover:bg-themeBtn-0 hover:border-themeBtn-0 duration-100 flex justify-between pt-4 pb-4 px-5">
          <div className="w-full">
            <p className="capitalize group-hover:text-white text-[#8F8F8F] text-sm mb-4">
              Recalls Revenue
            </p>
            <p className="text-black group-hover:text-white text-lg font-bold">
              $ {recalltotalRevenue}
            </p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 sm:gap-5 mt-6">
        <div className="rounded-lg border group border-[#F5F5F5] hover:bg-themeBtn-0 hover:border-themeBtn-0 duration-100 flex flex-col justify-between py-4 px-5">
          <div className="w-full mb-4">
            <p className="capitalize group-hover:text-white text-[#8F8F8F] text-sm mb-2">
              Total Revenue
            </p>
            <p className="text-black group-hover:text-white text-lg font-bold">
              $ {totalRevenue}
            </p>
          </div>
          <div className="h-[150px]">
            <Doughnut data={data} options={doughnutOptions} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Overview;
